<span [hidden]="loading">
  <ng-content></ng-content>
</span>
<app-progress-spinner *ngIf="loading"></app-progress-spinner>
